import React, {  useEffect, useState,useRef,useContext  } from "react";
import { GTMEvents } from '../_helpers/gtm/gtm';
import { useNavigate,Link,useParams  } from 'react-router-dom';
import Lang from '../lang/translations';
import Context from '../context/context';
import queryString from 'query-string';
import helpersFunction from "../_helpers/helpersFunction";




export default function Ok() {
    
    const query = queryString.parse(window.location.search);
    console.log(query)

    const context = useContext(Context)
    const navigate = useNavigate() 

    /*useEffect(() => {
        return navigate.listen((location) => { 
           context.setPageOkEnabled(false)
          }) 
     },[navigate])*/
    
    
     useEffect(() => {
     
        if(!context.pageOkEnabled){
            navigate('/chats')
        }else{
            //++++++++++++ Utente è diventato premium
            //ReactGA.pageview('/ok', "Purchase OK");

            
           
            setTimeout(function(){ 
                context.Socket.emit('chat', context.messaggioPending);
                context.setMessaggioPending(null);
                window.location.replace("/chats")  
            }, 6000);
        }
     },[])
    
    if(context.pageOkEnabled){
        return (<div className="all-container bg-light pianiAbbonamentoPage">
                    <div className="container filters-no-padding" role="main">
                        <div className="row">
                            <div className="col-md-7 col-12 col-centered">
                                <div class="jumbotron text-center">
                                        <img className="imgVip" src="/img/vip_comp.jpg"/>
                                        <h1 className="display-3">{Lang( {"w": "congratulazioni","page": "ok"} )}</h1>
                                        <p className="lead">{Lang( {"w": "utente_premium","page": "ok"} )}</p>
                                        <hr/>
                                    
                                        <p className="lead">
                                            <Link onClick={()=>{ window.location.reload();  }} className="btn btn-primary btn-sm" role="button">{Lang( {"w": "bottone_chat","page": "ok"} )}</Link>
                                        </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }else{
        return (<div></div>)
    }


}